import PropTypes from 'prop-types';
import DataGridContextProvider from '@common/components/DataGrid/DataGridContextProvider';

export default function DataGridFooter({ children }) {
  return (
    <DataGridContextProvider type="footer">
      <tfoot>{children}</tfoot>
    </DataGridContextProvider>
  );
}

DataGridFooter.propTypes = {
  children: PropTypes.node,
};
